export const SUBSCRIBER_UPDATE_PROFILE = "SUBSCRIBER_UPDATE_PROFILE";
